import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import AdminNavbar from "../Components/Adminnavbar";
import {
  FaRegCalendarAlt,
  FaUserTie,
  FaBuilding,
  FaPhoneAlt,
  FaChartPie,
  FaWallet,
  FaEye,
  FaCopy,
} from "react-icons/fa";
import { useDataContext } from "../Context/dataContext";
import { NotFound } from "./NotFound";
import { useNavigate } from "react-router-dom";
import { Modal } from "reactstrap";

function CreateOrder() {
  const navigate = useNavigate();
  const { url, infoTkn } = useDataContext();
  const [showModal, setShowModal] = useState(false);
  const [currency, setCurrency] = useState("");
  const [selectedOrder, setSelectedOrder] = useState({});
  const [copied, setCopied] = useState(false);

  const copyToClipboard = (address) => {
    navigator.clipboard.writeText(address);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  // Función para formatear la dirección (mostrar solo inicio y fin)
  const formatWalletAddress = (address) => {
    if (!address) return "Cargando..."; // Si aún no está disponible, muestra un texto temporal
    return `${address.slice(0, 6)}....${address.slice(-4)}`;
  };

  const toggle = () => {
    setShowModal(!showModal);
  };

  const [currencyBs, setCurrencyBs] = useState([]);

  const fetchCurrencyBs = useCallback(async () => {
    try {
      const response = await axios.get(`${url}/currency-price/1`, {
        headers: {
          Authorization: `Bearer ${infoTkn}`,
        },
      });
      setCurrencyBs(response.data.cur_bs);
    } catch (error) {
      console.log(error);
    }
  }, [infoTkn, url]);

  const [admin, setAdmin] = useState({});
  const [orders, setOrders] = useState([]);

  const fetchDataAdmin = useCallback(async () => {
    try {
      const response = await axios.get(
        `${url}/Auth/findByJWTAdmin/${infoTkn}`,
        {
          headers: {
            Authorization: `Bearer ${infoTkn}`,
          },
        }
      );
      setAdmin(response.data.data);

      const responseMovements = await axios.get(
        `${url}/Movements/admin/${response.data.data.adm_id}`,
        {
          headers: {
            Authorization: `Bearer ${infoTkn}`,
          },
        }
      );
      setOrders(responseMovements.data);
    } catch (error) {
      console.log(error);
    }
  }, [infoTkn, setAdmin, url]);

  const fetchCurrency = async () => {
    try {
      const response = await axios.get(
        "https://api.coingecko.com/api/v3/simple/price?ids=tether&vs_currencies=eur"
      );
      setCurrency(response.data.tether.eur);
      console.log(response.data.tether.eur);
    } catch (error) {
      console.error(error);
    }
  };

  const getFormattedDate = () => {
    const options = {
      weekday: "long",
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    };
    return new Date().toLocaleDateString("es-ES", options);
  };

  useEffect(() => {
    fetchDataAdmin();
    fetchCurrency();
    fetchCurrencyBs();
  }, [fetchDataAdmin, fetchCurrencyBs]);

  return admin ? (
    <div className="page-container">
      <AdminNavbar />

      <div className="content-container">
        {/* Sección superior con la fecha y bienvenida */}
        <div className="order-header">
          <div className="order-header__container">
            <div className="order-header__date">
              <FaRegCalendarAlt className="order-header__icon" />
              <span>{getFormattedDate()}</span>
            </div>
            <div className="order-header__welcome">
              <FaUserTie className="order-header__icon" />
              <span>
                Bienvenido, <strong>{admin.adm_user}</strong>
              </span>
            </div>
          </div>
        </div>

        {/* Sección de información de la empresa */}
        <div className="order-info">
          <h3 className="order-info__title">Detalles Comerciales</h3>
          <div className="order-info__details">
            <div className="order-info__item">
              <FaBuilding className="order-info__icon" />
              <span>
                <strong>Nombre Comercial:</strong> {admin.adm_user}
              </span>
            </div>
            <div className="order-info__item">
              <FaWallet className="order-info__icon" />
              <span>
                <strong>Dirección Wallet:</strong>{" "}
                {formatWalletAddress(admin.adm_wallet)}
                <FaCopy
                  className="wallet-copy-icon"
                  onClick={() => copyToClipboard(admin.adm_wallet)}
                  title="Copiar dirección"
                />
                {copied && (
                  <span className="wallet-copied-text"> ¡Copiada! </span>
                )}
              </span>
            </div>
            <div className="order-info__item">
              <FaPhoneAlt className="order-info__icon" />
              <span>
                <strong>Contacto:</strong> {admin.adm_name} {admin.adm_lastname}
              </span>
            </div>
            <div className="order-info__item">
              <FaChartPie className="order-info__icon" />
              <span>
                <strong>Porcentaje Manejado:</strong> {admin.adm_porcent}
              </span>
            </div>
          </div>
        </div>

        {/* Sección de Consulta de Fechas */}
        <div className="date-query">
          <h3>📌 Transacciones Pendientes</h3>

          {/* Tasas de Cambio */}
          <div className="date-query__rates">
            {[
              { label: "Tasa USDT Oficial", value: currency },
              {
                label: "Objetiva",
                value: currency * admin.adm_porcent + currency,
              },
              { label: "Tasa Bolívares", value: "1 USDT = Bs. " + currencyBs },
            ].map((rate, index) => (
              <div className="rate" key={index}>
                <div className="rate-label">{rate.label}</div>
                <div className="rate-value">{rate.value}</div>
              </div>
            ))}
          </div>

          {/* Tabla de Órdenes */}
          <div className="date-query__orders">
            <h3 className="date-query__subtitle">📌 Órdenes</h3>
            <table className="orders-table">
              <thead>
                <tr>
                  <th>Euros</th>
                  <th>Cliente</th>
                  <th>Comprobante</th>
                  <th>Cálculo</th>
                  <th>Estado</th>
                </tr>
              </thead>
              <tbody>
                {orders
                  .filter((order) => order.mov_status === "P")
                  .map((order) => (
                    <tr key={order.mov_id}>
                      <td>€ {order.mov_amount}</td>
                      <td>
                        {order.User.use_name} {order.User.use_lastName}
                      </td>
                      <td>
                        <button
                          className="btn-view"
                          onClick={() => {
                            toggle();
                            setSelectedOrder(order);
                          }}
                        >
                          <FaEye /> Ver
                        </button>
                      </td>
                      {order.mov_conversionType === "Usdt" && (
                        <td>
                          {" "}
                          {order.mov_conversionType}{" "}
                          {(
                            order.mov_amount /
                            (currency * admin.adm_porcent + currency)
                          ).toFixed(2)}
                        </td>
                      )}
                      {order.mov_conversionType === "Bs" && (
                        <td>
                          {order.mov_conversionType}{" "}
                          {(
                            (order.mov_amount /
                              (currency * admin.adm_porcent + currency)) *
                            currencyBs
                          ).toFixed(2)}
                        </td>
                      )}
                      <td className={`status`}>
                        {order.mov_status === "P" && (
                          <span className="status-pending">🟡 En espera</span>
                        )}
                        {order.mov_status === "V" && (
                          <span className="status-verified">✅ Verificado</span>
                        )}
                        {order.mov_status === "R" && (
                          <span className="status-rejected">❌ Rechazado</span>
                        )}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>

          <Modal isOpen={showModal} toggle={toggle}>
            <div className="modal-header">
              <h5 className="modal-title">Comprobante de Pago</h5>
              <button
                type="button"
                className="btn-close"
                onClick={toggle}
              ></button>
            </div>
            <div className="modal-body">
              <img
                src={`${url}/Movements/proof/${selectedOrder.mov_proof}`}
                alt="Comprobante de Pago"
              />
            </div>
          </Modal>

          {/* Botón Crear Orden */}
          <div className="date-query__create-order">
            <button onClick={() => navigate("/Order")}>➕ Crear Orden</button>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <NotFound />
  );
}

export { CreateOrder };
